import React, { useState } from 'react';
import { Button, Card, Alert, Badge } from 'react-bootstrap';
import axios from 'axios';

export default function JobMonitorTest() {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const runTest = async (testName, testFunction) => {
    setLoading(true);
    try {
      const result = await testFunction();
      setTestResults(prev => [...prev, {
        name: testName,
        success: true,
        result: result,
        timestamp: new Date()
      }]);
    } catch (error) {
      setTestResults(prev => [...prev, {
        name: testName,
        success: false,
        error: error.message,
        timestamp: new Date()
      }]);
    } finally {
      setLoading(false);
    }
  };

  const testGetStatus = async () => {
    const response = await axios.get('/job-monitor/status');
    return response.data;
  };

  const testUpdateSettings = async () => {
    const testSettings = {
      postcodeAreas: ['EX12', 'EX13'],
      alertSettings: {
        screenFlash: true,
        soundAlert: true,
        emailAlert: false,
        checkInterval: 5,
        autoStopAfterMinutes: 30
      }
    };
    
    const response = await axios.post('/job-monitor/settings', testSettings);
    return response.data;
  };

  const testToggleMonitoring = async () => {
    const response = await axios.post('/job-monitor/toggle', { isActive: true });
    return response.data;
  };

  const testCheckJobs = async () => {
    const response = await axios.post('/job-monitor/check');
    return response.data;
  };

  const testGetHistory = async () => {
    const response = await axios.get('/job-monitor/history');
    return response.data;
  };

  const testGetCount = async () => {
    const response = await axios.get('/job-monitor/count');
    return response.data;
  };

  const runAllTests = async () => {
    setTestResults([]);
    
    await runTest('Get Status', testGetStatus);
    await runTest('Update Settings', testUpdateSettings);
    await runTest('Toggle Monitoring', testToggleMonitoring);
    await runTest('Check Jobs', testCheckJobs);
    await runTest('Get History', testGetHistory);
    await runTest('Get Count', testGetCount);
  };

  const clearResults = () => {
    setTestResults([]);
  };

  return (
    <div className="container mt-4">
      <Card>
        <Card.Header>
          <h4>Job Monitor Test Suite</h4>
        </Card.Header>
        <Card.Body>
          <div className="mb-3">
            <Button 
              variant="primary" 
              onClick={runAllTests} 
              disabled={loading}
              className="me-2"
            >
              {loading ? 'Running Tests...' : 'Run All Tests'}
            </Button>
            <Button variant="outline-secondary" onClick={clearResults}>
              Clear Results
            </Button>
          </div>

          {testResults.length > 0 && (
            <div>
              <h5>Test Results:</h5>
              {testResults.map((test, index) => (
                <Alert 
                  key={index} 
                  variant={test.success ? 'success' : 'danger'}
                  className="mb-2"
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <strong>{test.name}</strong>
                      <br />
                      <small className="text-muted">
                        {test.timestamp.toLocaleString()}
                      </small>
                    </div>
                    <Badge bg={test.success ? 'success' : 'danger'}>
                      {test.success ? 'PASS' : 'FAIL'}
                    </Badge>
                  </div>
                  
                  {test.success ? (
                    <pre className="mt-2 mb-0" style={{ fontSize: '0.8rem' }}>
                      {JSON.stringify(test.result, null, 2)}
                    </pre>
                  ) : (
                    <div className="mt-2 text-danger">
                      Error: {test.error}
                    </div>
                  )}
                </Alert>
              ))}
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
} 